// *disable-eslint*

/* eslint-disable */

(function ($, Drupal, drupalSettings, once) {
  'use strict';

  (function($) {
    $.QueryString = (function(a) {
      if (a === "") return {};
      var b = {};
      for (var i = 0; i < a.length; ++i)
      {
        var p=a[i].split('=', 2);
        if (p.length != 2) continue;
        if (b[p[0]]) continue;
        b[p[0]] = decodeURIComponent(p[1].replace(/\+/g, " "));
      }
      return b;
    })(window.location.search.substr(1).split('&'));
  })(jQuery);

  function setMultiWithChildren(select, value) {
    var inParent = false;
    var toSelect = [];
    select.val([]);
    select.find('option').each(function () {
      if ($(this).val() == value) {
        toSelect.push($(this).val());
        inParent = true;
        return;
      }
      if(inParent) {
        if ($(this).text().charAt(0) == '-') {
          toSelect.push($(this).val());
          return;
        } else {
          inParent = false;
          return;
        }
      }
    });
    select.val(toSelect);
  }

  Drupal.behaviors.tripplanner = {
    setHidden: function(name, value) {
      if ($('form.views-exposed-form :input[name=' + name + ']').length === 0) {
        $('<input type="hidden" name="' + name + '" value="' + value + '">').appendTo($('form.views-exposed-form'));
      }
      else {
        $('form.views-exposed-form :input[name='+name+']').val(value);
      }
    },
    setURL: function() {
      if (history.pushState) {
        window.history.pushState({path:this.getURL()}, '', this.getURL());
      }
    },
    getURL: function() {
      var url = ''; // $('form.views-exposed-form :input[value!=""]').serialize();
      // Check region.
      if ($('form.views-exposed-form :input[name*=region]').val().length > 0) {
        //url += '&region=' + $('form.views-exposed-form :input[name*=region]').val()[0];
        url += '&region=' + $('.form-item-location .pselect-display-value').html();
        this.setHidden('region', $('.form-item-location .pselect-display-value').html());
      }
      // Check city.
      if ($('form.views-exposed-form :input[name*=city]').val().length > 0) {
        url += '&city=' + $('.form-item-location .pselect-display-value').html();
        this.setHidden('city', $('.form-item-location .pselect-display-value').html());
      }
      // Check category.
      if ($('form.views-exposed-form :input[name*=content_category]').val().length > 0 && $('form.views-exposed-form :input[name*=content_category]').val()[0] !== "0") {
        url += '&category=' + $('form.views-exposed-form :input[name*=content_category]').val()[0];
        this.setHidden('category', $('form.views-exposed-form :input[name*=content_category]').val()[0]);
      }
      // Check family friendly.
      if ($('form.views-exposed-form :input[name*=family]').val() === "1") {
        url += '&family_friendly=1';
        this.setHidden('family_friendly', 1);
      }
      return [location.protocol, '//', location.host, location.pathname].join('') + '?' + url.replace(/^&/, '');
    },
    filterSubmit: function() {
      this.setURL();
      $('form.views-exposed-form :input[name*=filtered]').val('1');
      $('form.views-exposed-form input.form-submit').click();
      $('form.views-exposed-form :input[name*=filtered]').val('0');
    },
    attach: function () {
      var urlRegion = $.QueryString.region;
      var urlCity = $.QueryString.city;
      var urlCat = $.QueryString.category;
      var urlFF = $.QueryString.family_friendly;

      var urlLocation = '';
      if (urlRegion) {
        urlLocation = urlRegion;
      } else if (urlCity) {
        urlLocation = urlCity;
      }

      var location_field = $('.block-tnv-tripplanner-filters-form .form-item-location:not(.tp-processed)');

      if(location_field.length > 0) {
        var location = location_field.addClass('processed').pSelect(
          {
            default: urlLocation,
            searchElement: $('.block-tnv-tripplanner-filters-form .form-item-city-search'),
            onChange: function (option) {
              if (option.data('filterType') == 'cities') {
                // Clear region filters
                $('form.views-exposed-form select[name*=region]').val([]);
                // Set City Filters
                $('form.views-exposed-form input[name*=city]').val(option.data('filterValue'));
                // Submit form.
                Drupal.behaviors.tripplanner.filterSubmit();
              }
              else if (option.data('filterType') == 'regions') {
                // Clear City filters.
                $('form.views-exposed-form input[name*=city]').val('');
                // Set Region filters.
                setMultiWithChildren($('form.views-exposed-form select[name*=region]'), option.data('filterValue'));

                // Submit form.
                Drupal.behaviors.tripplanner.filterSubmit();
              }
            },
            onClear: function() {
              // Clear City filters.
              $('form.views-exposed-form input[name*=city]').val('');
              // Clear region filters
              $('form.views-exposed-form select[name*=region]').val([]);
              // Submit form.
              Drupal.behaviors.tripplanner.filterSubmit();
            }
          }
        );
      }
      var catChild = null;
      var catParent = null;

      var child_field = $('.block-tnv-tripplanner-filters-form .form-item-category-child:not(.tp-processed)');
      var parent_field = $('.block-tnv-tripplanner-filters-form .form-item-category-parent:not(.tp-processed)');

      if(child_field.length > 0) {
        catChild = child_field.addClass('processed').pSelect(
          {
            default: urlCat,
            disabled: true,
            onChange: function (option) {
              $('form.views-exposed-form select[name^=content_category]').val(option.data('filterValue'));
              // Submit form.
              Drupal.behaviors.tripplanner.filterSubmit();
            },
            onClear: function(plugin) {
              // Reset to parent value.
              setMultiWithChildren($('form.views-exposed-form select[name^=content_category]'), plugin.settings.optGroupId);
              // Submit form.
              Drupal.behaviors.tripplanner.filterSubmit();
            }
          }
        );
      }

      if(parent_field.length > 0) {
        catParent = parent_field.addClass('processed').pSelect(
          {
            default: urlCat,
            cascade: true,
            cascadeTarget: catChild,
            onChange: function (option) {
              // Catch Events category and redirect to calendar.
              if (option.data('filterValue') == '11') {
                window.location.replace('/calendar');
                return false;
              }
              // Set to parent value.
              setMultiWithChildren($('form.views-exposed-form select[name^=content_category]'), option.data('filterValue'));
              // Submit form.
              Drupal.behaviors.tripplanner.filterSubmit();
            },
            onClear: function(plugin) {
              // Reset.
              $('form.views-exposed-form select[name^=content_category]').val(0);
              // Submit form.
              Drupal.behaviors.tripplanner.filterSubmit();
            }
          }
        );
      }

      // Set Parent if Child was set by URL.
      if (catChild && catChild.length && catChild.data('pSelect').getValue() && catParent && catParent.length && !catParent.data('pSelect').getValue()) {
        catParent.data('pSelect').initialSelect(catChild.data('pSelect').settings.optGroupId);
      }

      $('.block-tnv-tripplanner input[data-drupal-selector=edit-city-search]').on('autocompleteclose', function (e) {
        var str = e.target.value;
        var match = str.match(/\((\d*)\)/);
        if (match) {
          $(this).val(str.replace(match[0], ''));
          window.location.href = '/trip-planner?category=All&location_city=' + match[1];
        }
      });

      // Set Family Friendly filters.
      $('form#block-tnv-tripplanner-filters-form input[name^=family]:not(.url_processed)').addClass('url_processed').prop("checked", (urlFF === '1') ? true: false);

      $('form#block-tnv-tripplanner-filters-form input[name^=family]').on('change', function (e) {
        $('form.views-exposed-form select[name^=family]').val($(this).is(':checked') ? 1 : 'All');
        // Submit form.
        Drupal.behaviors.tripplanner.filterSubmit();
      });

      // Disable form submission on the fake filter form.
      $('#block-tnv-tripplanner-filters-form').submit(function (e) {e.preventDefault();});

      $('.custom-select-display-value').click(function (e) {
        $('.custom-select-options a').attr('tabindex', -1);
        $('.custom-select-wrapper').removeClass('active');
        $(this).closest('div').addClass('active');
        $(this).closest('div').find('.custom-select-options a').attr('tabindex', 0);
        e.preventDefault();
      });

      $('.custom-select-options a').click(function (e) {
        var text = $(e.target).text();
        $(this).parents('.custom-select-wrapper').find('.custom-select-display-value').html(text);
        $(this).closest('.custom-select-wrapper').removeClass('active');
        $('.custom-select-options a').attr('tabindex', -1);
      });

      $(document).on('click', function (e) {
        if ($(e.target).parents('.custom-select').length === 0) {
          $('.custom-select-wrapper').removeClass('active');
          $('.custom-select-options a').attr('tabindex', -1);
        }
      });

      $(once('wrapper', '.custom-select-wrapper > a')).keydown(function (e) {
        if (e.which == 40) {
          $(this).click();
          $(this).next().find('a:first').focus();
          e.preventDefault();
        }
      });

      $(once('options', '.custom-select-options > a')).keydown(function (e) {
        if (e.which == 40) {
          if ($(this).next().is("div")) {
            $(this).next().next().focus();
          } else {
            $(this).next().focus();
          }
          e.preventDefault();
        }
        else if (e.which == 38) {
          if ($(this).prev().is("div")) {
            $(this).prev().prev().focus();
          } else {
            $(this).prev().focus();
          }
          e.preventDefault();
        }
      });
    }
  };
})(jQuery, Drupal, drupalSettings, once); // eslint-disable-line no-undef
